module.exports = __webpack_public_path__ + "img/other-panel.faa450f.svg";